import { createContext, useContext, useState } from 'react';
import { CartItemType } from './useCartContext';

interface IContext {
  giftItem?: CartItemType;
  setGiftItem: (giftItem: CartItemType) => void;
  recipient: string;
  setRecipient: (user: string) => void;
  message: string;
  setMessage: (user: string) => void;
  decrement: () => void;
  increment: () => void;
  reset: () => void;
  isReady: () => boolean;
}

const GiftContext = createContext<IContext | undefined>(undefined);

export const GiftContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [giftItem, setGiftItem] = useState<CartItemType | undefined>();
  const [recipient, setRecipient] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const increment = () => {
    if (!giftItem) return;
    const updatedGiftItem = { ...giftItem, quantity: giftItem.quantity + 1 };

    setGiftItem(updatedGiftItem);
  };

  const decrement = () => {
    if (!giftItem) return;

    const updatedItem = { ...giftItem, quantity: giftItem.quantity - 1 };

    setGiftItem(updatedItem);
  };

  const reset = () => {
    setGiftItem(undefined);
    setRecipient('');
    setMessage('');
  };

  const isReady = () => (giftItem && recipient ? true : false);

  return (
    <GiftContext.Provider
      value={{
        giftItem,
        setGiftItem,
        message,
        setMessage,
        recipient,
        setRecipient,
        decrement,
        increment,
        reset,
        isReady,
      }}
    >
      {children}
    </GiftContext.Provider>
  );
};

export const useGiftContext = () => {
  const context = useContext(GiftContext);
  if (!context)
    throw new Error(
      'No GiftContext.Provider found when calling useGiftContext',
    );
  return context;
};
